import { useEffect, useState } from 'react';

export const useCallDealer = () => {
  const [shouldAutoGenNumber, setShouldAutoGenNumber] = useState(false);

  //should auto generate number
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.get('call-dealer') !== null && shouldAutoGenNumber === false) {
      setShouldAutoGenNumber(true);
    }
  }, [shouldAutoGenNumber]);

  return { shouldAutoGenNumber };
};
